// "use client";

// import { useState, useEffect, useRef, useCallback, Suspense } from "react";
// import { useRouter, useSearchParams } from "next/navigation";
// import { MapPin, Loader2, Search } from "lucide-react";
// import { CalendarDropdown } from "./CalendarDropdown";
// import { PeopleCountDropdown } from "./PeopleCountDropdown";
// import type { SearchValues } from "../types";

// const datePopStyle = `
//   .date-field-pop *, input, button, select, textarea {
//     outline: none !important;
//     box-shadow: none !important;
//   }
//   input:focus, button:focus, select:focus, textarea:focus {
//     outline: none !important;
//     box-shadow: none !important;
//   }
//   @keyframes lilylankaDatePop {
//     0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(124,58,237,0.45); }
//     30% { transform: scale(1.04); box-shadow: 0 0 0 6px rgba(124,58,237,0.25); }
//     60% { transform: scale(0.99); box-shadow: 0 0 0 2px rgba(124,58,237,0.15); }
//     100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(124,58,237,0); }
//   }
//   .date-field-pop {
//     animation: lilylankaDatePop 0.65s cubic-bezier(0.34, 1.56, 0.64, 1);
//     border-radius: 0.5rem;
//   }
//   @keyframes lilylankaSearchBarPop {
//     0% { opacity: 0; transform: scaleX(0.55) scaleY(0.85); }
//     55% { opacity: 1; transform: scaleX(1.03) scaleY(1.03); }
//     75% { transform: scaleX(0.99) scaleY(0.99); }
//     100% { opacity: 1; transform: scaleX(1) scaleY(1); }
//   }
//   .search-bar-pop-in {
//     animation: lilylankaSearchBarPop 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;
//     transform-origin: center center;
//   }
//   @keyframes lilylankaButtonPop {
//     0% { transform: scale(0.55); opacity: 0; box-shadow: 0 0 0 0 rgba(124,58,237,0); }
//     45% { transform: scale(1.14); opacity: 1; box-shadow: 0 0 0 12px rgba(124,58,237,0.25); }
//     70% { transform: scale(0.97); box-shadow: 0 0 0 4px rgba(124,58,237,0.12); }
//     100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(124,58,237,0); }
//   }
//   .search-button-pop {
//     animation: lilylankaButtonPop 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
//   }
//   @keyframes lilylankaFieldFadeUp {
//     0% { opacity: 0; transform: translateY(10px); }
//     100% { opacity: 1; transform: translateY(0); }
//   }
//   .field-fade-up {
//     animation: lilylankaFieldFadeUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
//   }
// `;

// // ─────────────────────────────────────────────────────────
// // LOCATION INPUT
// // ─────────────────────────────────────────────────────────
// const LocationInputList = ({
//   initialLocation,
//   onLocationChange,
//   onLocationSelect,
//   onSearch,
// }: {
//   initialLocation: string;
//   onLocationChange: (location: string, locationId?: number) => void;
//   onLocationSelect: (location: string, locationId: number) => void;
//   onSearch: () => void;
// }) => {
//   const [inputValue, setInputValue] = useState(initialLocation);
//   const [suggestions, setSuggestions] = useState<any[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const timeoutRef = useRef<NodeJS.Timeout>(null);
//   const wrapperRef = useRef<HTMLDivElement>(null);
//   const inputRef = useRef<HTMLInputElement>(null);

//   useEffect(() => {
//     setInputValue(initialLocation);
//   }, [initialLocation]);

//   useEffect(() => {
//     function handleClickOutside(event: MouseEvent) {
//       if (
//         wrapperRef.current &&
//         !wrapperRef.current.contains(event.target as Node)
//       ) {
//         setShowSuggestions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleChange = (value: string) => {
//     setInputValue(value);
//     onLocationChange(value, undefined);
//     if (value.length < 2) {
//       setSuggestions([]);
//       setShowSuggestions(false);
//       return;
//     }
//     if (timeoutRef.current) clearTimeout(timeoutRef.current);
//     timeoutRef.current = setTimeout(async () => {
//       setLoading(true);
//       try {
//         const params = new URLSearchParams({
//           q: value,
//           page: "1",
//           pageSize: "10",
//         });
//         const response = await fetch(
//           `https://www.lilylanka.com/api/CustomerDestinations?${params.toString()}`,
//           {
//             method: "GET",
//             headers: { Accept: "application/json" },
//             cache: "no-store",
//           },
//         );
//         if (response.ok) {
//           const data = await response.json();
//           const locations =
//             data.destinations?.map((dest: any) => ({
//               uid: dest.id,
//               name: dest.name,
//               district: dest.district,
//               province: dest.province,
//             })) || [];
//           setSuggestions(locations);
//           setShowSuggestions(locations.length > 0);
//         }
//       } catch {
//         setSuggestions([]);
//         setShowSuggestions(false);
//       } finally {
//         setLoading(false);
//       }
//     }, 300);
//   };

//   const selectLocation = (location: any) => {
//     setInputValue(location.name);
//     onLocationSelect(location.name, location.uid);
//     setShowSuggestions(false);
//     setSuggestions([]);
//   };

//   return (
//     <div className="relative w-full" ref={wrapperRef}>
//       {/* ⚠️ was missing dark: bg + text */}
//       <div className="flex items-center gap-2 px-3 sm:px-4 h-10 sm:h-11 bg-transparent w-full touch-manipulation rounded-lg">
//         <svg
//           className="w-4 h-4 sm:w-5 sm:h-5 text-white dark:text-white flex-shrink-0"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//           strokeWidth={1.8}
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         >
//           <path d="M22 2L11 13" />
//           <path d="M22 2L15 22l-4-9-9-4 19-7z" />
//         </svg>
//         <input
//           ref={inputRef}
//           type="text"
//           value={inputValue}
//           onChange={(e) => handleChange(e.target.value)}
//           onKeyDown={(e) => {
//             if (e.key === "Enter") {
//               e.preventDefault();
//               onSearch();
//             }
//           }}
//           onFocus={() => {
//             if (suggestions.length > 0) setShowSuggestions(true);
//           }}
//           placeholder="Where are you going?"
//           // ⚠️ was hardcoded text-gray-900
//           className="flex-1 bg-transparent outline-none focus:outline-none focus:ring-0 placeholder:text-white dark:placeholder:text-white text-xs sm:text-sm text-gray-900 dark:text-zinc-100 min-w-0"
//           autoComplete="off"
//           inputMode="text"
//           enterKeyHint="search"
//         />
//         {loading && (
//           <Loader2 className="w-3.5 h-3.5 sm:w-4 sm:h-4 animate-spin text-gray-400 dark:text-zinc-500 flex-shrink-0" />
//         )}
//       </div>

//       {showSuggestions && suggestions.length > 0 && (
//         <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-zinc-900 border border-gray-100 dark:border-zinc-800 rounded-xl shadow-xl z-[999] max-h-72 overflow-y-auto">
//           {suggestions.map((s) => (
//             <button
//               key={s.uid}
//               type="button"
//               onClick={() => selectLocation(s)}
//               className="w-full px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-zinc-800 active:bg-gray-100 dark:active:bg-zinc-700 flex items-center gap-3 border-b border-gray-100 dark:border-zinc-800 last:border-b-0 touch-manipulation transition-colors"
//             >
//               <MapPin className="w-4 h-4 text-gray-400 dark:text-zinc-500 flex-shrink-0" />
//               <div className="flex-1 min-w-0">
//                 <div className="font-semibold text-sm text-gray-900 dark:text-zinc-100">
//                   {s.name}
//                 </div>
//                 <div className="text-xs text-gray-500 dark:text-zinc-400">
//                   {s.district}, {s.province}
//                 </div>
//               </div>
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// // ─────────────────────────────────────────────────────────
// // ERROR TOOLTIP
// // ─────────────────────────────────────────────────────────
// function ErrorTooltip({ message }: { message: string }) {
//   return (
//     <div className="absolute left-0 right-0 top-full mt-1 z-50">
//       <div className="bg-red-600 text-white text-xs font-medium px-3 py-2 rounded-lg shadow-lg flex items-center gap-2">
//         <span className="flex-shrink-0">⚠</span>
//         {message}
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────
// // FIELD WRAPPER — consistent border + dark bg
// // ─────────────────────────────────────────────────────────
// function FieldWrap({
//   children,
//   error,
//   className = "",
// }: {
//   children: React.ReactNode;
//   error?: boolean;
//   className?: string;
// }) {
//   return (
//     // ⚠️ original had hardcoded bg-white with no dark: variant on wrappers
//     <div
//       className={`border rounded-lg bg-white/10 dark:bg-zinc-900/20 hover:bg-white/20 dark:hover:bg-zinc-900/30 hover:border-white/50 dark:hover:border-zinc-600 transition-colors overflow-visible focus-within:outline-none focus-within:ring-0 focus-within:border-purple-400 dark:focus-within:border-purple-500 ${
//         error
//           ? "border-red-500 dark:border-red-500"
//           : "border-white/30 dark:border-zinc-700"
//       } ${className}`}
//     >
//       {children}
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────
// // MAIN COMPONENT
// // ─────────────────────────────────────────────────────────
// function HotelSearchBarContent({
//   variant = "list",
//   onValuesChange,
// }: {
//   variant?: "list";
//   onValuesChange?: (values: SearchValues) => void;
// }) {
//   const router = useRouter();
//   const searchParams = useSearchParams();
//   const [isMobile, setIsMobile] = useState(false);
//   const [values, setValues] = useState<SearchValues>({
//     location: "",
//     locationId: undefined,
//     checkIn: "",
//     checkOut: "",
//     guests: 2,
//     adults: 2,
//     children: 0,
//     rooms: 1,
//     searchText: "",
//   });
//   const [locationError, setLocationError] = useState(false);
//   const [dateError, setDateError] = useState(false);
//   const [datePop, setDatePop] = useState(false);

//   // ── Entrance choreography: button pops in first, then fields grow open ──
//   const [fieldsRevealed, setFieldsRevealed] = useState(false);
//   // Becomes true once the grow-in animation has fully settled — only then is
//   // overflow switched to visible, so dropdowns/calendars/guest pickers are
//   // never clipped, but the field also never "pops" unclipped mid-animation.
//   const [revealSettled, setRevealSettled] = useState(false);

//   useEffect(() => {
//     const t1 = setTimeout(() => setFieldsRevealed(true), 350);
//     const t2 = setTimeout(() => setRevealSettled(true), 1150);
//     return () => {
//       clearTimeout(t1);
//       clearTimeout(t2);
//     };
//   }, []);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth < 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   useEffect(() => {
//     const handleRequireDates = () => {
//       setDateError(true);
//       setDatePop(true);
//       setTimeout(() => setDatePop(false), 650);
//     };
//     window.addEventListener("lilylanka:require-dates", handleRequireDates);
//     return () =>
//       window.removeEventListener("lilylanka:require-dates", handleRequireDates);
//   }, []);

//   useEffect(() => {
//     const location = searchParams.get("location") || "";
//     const locationId = searchParams.get("locationId");
//     const checkIn = searchParams.get("checkIn") || "";
//     const checkOut = searchParams.get("checkOut") || "";
//     const adults = parseInt(searchParams.get("adults") || "2");
//     const children = parseInt(searchParams.get("children") || "0");
//     const rooms = parseInt(searchParams.get("rooms") || "1");
//     const searchText = searchParams.get("searchText") || "";
//     setValues({
//       location,
//       locationId: locationId ? parseInt(locationId) : undefined,
//       checkIn,
//       checkOut,
//       guests: adults + children,
//       adults,
//       children,
//       rooms,
//       searchText,
//     });
//   }, [searchParams]);

//   useEffect(() => {
//     onValuesChange?.(values);
//   }, [values.adults, values.children, values.rooms, values.searchText]);

//   const handleSearch = useCallback(() => {
//     const hasDateError = !values.checkIn || !values.checkOut;
//     setLocationError(false);
//     setDateError(hasDateError);
//     if (hasDateError) return;

//     const totalGuests = values.adults + values.children;
//     const params = new URLSearchParams({
//       location: values.location,
//       checkIn: values.checkIn,
//       checkOut: values.checkOut,
//       guests: String(totalGuests || 1),
//       adults: String(values.adults),
//       children: String(values.children),
//       rooms: String(values.rooms),
//     });
//     if (values.locationId) params.set("locationId", String(values.locationId));
//     router.push("/hotels?" + params.toString());
//   }, [values, router]);

//   const handleLocationChange = useCallback(
//     (location: string, locationId?: number) => {
//       setValues((prev) => ({ ...prev, location, locationId }));
//     },
//     [],
//   );

//   const handleLocationSelect = useCallback(
//     (location: string, locationId: number) => {
//       setValues((prev) => ({ ...prev, location, locationId }));
//     },
//     [],
//   );

//   if (variant === "list") {
//     return (
//       // ⚠️ outer wrapper was missing dark: border + bg
//       <>
//         <style dangerouslySetInnerHTML={{ __html: datePopStyle }} />
//         <div className="search-bar-pop-in bg-white/20 dark:bg-zinc-900/30 backdrop-blur-xl border border-white/30 dark:border-zinc-700/40 rounded-lg overflow-visible shadow-lg">
//           <div className="max-w-6xl mx-auto px-3 sm:px-4 lg:px-6 py-2 sm:py-4 overflow-visible">
//             {isMobile ? (
//               <div className="flex flex-col gap-2">
//                 <div
//                   className={`relative ${datePop ? "date-field-pop" : ""} ${
//                     fieldsRevealed ? "field-fade-up" : "opacity-0"
//                   }`}
//                   style={{ animationDelay: "120ms" }}
//                 >
//                   <FieldWrap error={dateError}>
//                     <LocationInputList
//                       initialLocation={values.location}
//                       onLocationChange={(loc, id) => {
//                         handleLocationChange(loc, id);
//                         if (loc.trim()) setLocationError(false);
//                       }}
//                       onLocationSelect={(loc, id) => {
//                         handleLocationSelect(loc, id);
//                         setLocationError(false);
//                       }}
//                       onSearch={handleSearch}
//                     />
//                   </FieldWrap>
//                   {locationError && (
//                     <ErrorTooltip message="Please enter a destination to start searching." />
//                   )}
//                 </div>

//                 <div
//                   className={`relative ${
//                     fieldsRevealed ? "field-fade-up" : "opacity-0"
//                   }`}
//                   style={{ animationDelay: "220ms" }}
//                 >
//                   <FieldWrap error={dateError}>
//                     <CalendarDropdown
//                       checkIn={values.checkIn}
//                       checkOut={values.checkOut}
//                       onCheckInChange={(v) => {
//                         setValues((s) => ({ ...s, checkIn: v }));
//                         if (v) setDateError(false);
//                       }}
//                       onCheckOutChange={(v) => {
//                         setValues((s) => ({ ...s, checkOut: v }));
//                         if (v) setDateError(false);
//                       }}
//                     />
//                   </FieldWrap>
//                   {dateError && (
//                     <ErrorTooltip message="Please select check-in and check-out dates." />
//                   )}
//                 </div>

//                 <div
//                   className={fieldsRevealed ? "field-fade-up" : "opacity-0"}
//                   style={{ animationDelay: "320ms" }}
//                 >
//                   <FieldWrap>
//                     <PeopleCountDropdown
//                       values={values}
//                       setValues={setValues}
//                     />
//                   </FieldWrap>
//                 </div>

//                 <button
//                   onClick={handleSearch}
//                   className="search-button-pop w-full flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-700 active:bg-purple-800 text-white font-semibold rounded-full py-3 text-sm ring-4 ring-purple-300/40 dark:ring-purple-500/30 transition-colors touch-manipulation cursor-pointer"
//                 >
//                   <Search className="w-4 h-4" strokeWidth={2.5} />
//                   Search
//                 </button>
//               </div>
//             ) : (
//               <div className="flex items-stretch justify-center gap-2 sm:gap-3">
//                 <div
//                   className="relative min-w-0 basis-0 transition-all ease-out"
//                   style={{
//                     flexGrow: fieldsRevealed ? 1 : 0,
//                     opacity: fieldsRevealed ? 1 : 0,
//                     overflow: revealSettled ? "visible" : "hidden",
//                     transitionDuration: "650ms",
//                     transitionDelay: "120ms",
//                   }}
//                 >
//                   <FieldWrap error={locationError}>
//                     <LocationInputList
//                       initialLocation={values.location}
//                       onLocationChange={(loc, id) => {
//                         handleLocationChange(loc, id);
//                         if (loc.trim()) setLocationError(false);
//                       }}
//                       onLocationSelect={(loc, id) => {
//                         handleLocationSelect(loc, id);
//                         setLocationError(false);
//                       }}
//                       onSearch={handleSearch}
//                     />
//                   </FieldWrap>
//                   {locationError && (
//                     <ErrorTooltip message="Please enter a destination to start searching." />
//                   )}
//                 </div>

//                 <div
//                   className={`relative min-w-0 basis-0 transition-all ease-out ${
//                     datePop ? "date-field-pop" : ""
//                   }`}
//                   style={{
//                     flexGrow: fieldsRevealed ? 1 : 0,
//                     opacity: fieldsRevealed ? 1 : 0,
//                     overflow: revealSettled ? "visible" : "hidden",
//                     transitionDuration: "650ms",
//                     transitionDelay: "240ms",
//                   }}
//                 >
//                   <FieldWrap error={dateError}>
//                     <CalendarDropdown
//                       checkIn={values.checkIn}
//                       checkOut={values.checkOut}
//                       onCheckInChange={(v) => {
//                         setValues((s) => ({ ...s, checkIn: v }));
//                         if (v) setDateError(false);
//                       }}
//                       onCheckOutChange={(v) => {
//                         setValues((s) => ({ ...s, checkOut: v }));
//                         if (v) setDateError(false);
//                       }}
//                     />
//                   </FieldWrap>
//                   {dateError && (
//                     <ErrorTooltip message="Please select check-in and check-out dates." />
//                   )}
//                 </div>

//                 <div
//                   className="min-w-0 basis-0 transition-all ease-out"
//                   style={{
//                     flexGrow: fieldsRevealed ? 1 : 0,
//                     opacity: fieldsRevealed ? 1 : 0,
//                     overflow: revealSettled ? "visible" : "hidden",
//                     transitionDuration: "650ms",
//                     transitionDelay: "360ms",
//                   }}
//                 >
//                   <FieldWrap>
//                     <PeopleCountDropdown
//                       values={values}
//                       setValues={setValues}
//                     />
//                   </FieldWrap>
//                 </div>

//                 <button
//                   onClick={handleSearch}
//                   className="search-button-pop flex-shrink-0 flex items-center gap-2 bg-purple-600 hover:bg-purple-700 active:bg-purple-800 text-white font-semibold rounded-full px-6 sm:px-8 py-2.5 text-sm ring-4 ring-purple-300/40 dark:ring-purple-500/30 transition-colors whitespace-nowrap cursor-pointer"
//                 >
//                   <Search className="w-4 h-4" strokeWidth={2.5} />
//                   Search
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </>
//     );
//   }

//   return null;
// }

// // ─────────────────────────────────────────────────────────
// // WRAPPER + EXPORT
// // ─────────────────────────────────────────────────────────
// function HotelSearchBarWrapper({
//   variant = "list",
//   onValuesChange,
// }: {
//   variant?: "list";
//   onValuesChange?: (values: SearchValues) => void;
// }) {
//   const [mounted, setMounted] = useState(false);
//   useEffect(() => {
//     setMounted(true);
//   }, []);

//   if (!mounted) {
//     return (
//       // ⚠️ skeleton was missing dark: bg
//       <div className="w-full rounded-2xl bg-white/95 dark:bg-zinc-900/95 shadow-xl px-4 py-3 animate-pulse">
//         <div className="h-10 bg-gray-200 dark:bg-zinc-700 rounded" />
//       </div>
//     );
//   }

//   return (
//     <HotelSearchBarContent variant={variant} onValuesChange={onValuesChange} />
//   );
// }

// export default function HotelSearchBar({
//   variant = "list",
//   onValuesChange,
// }: {
//   variant?: "list";
//   onValuesChange?: (values: SearchValues) => void;
// }) {
//   return (
//     <Suspense
//       fallback={
//         <div className="w-full rounded-2xl bg-white/95 dark:bg-zinc-900/95 shadow-xl px-4 py-3 animate-pulse">
//           <div className="h-10 bg-gray-200 dark:bg-zinc-700 rounded" />
//         </div>
//       }
//     >
//       <HotelSearchBarWrapper
//         variant={variant}
//         onValuesChange={onValuesChange}
//       />
//     </Suspense>
//   );
// }

"use client";

import { useState, useEffect, useRef, useCallback, Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { MapPin, Loader2, Search } from "lucide-react";
import { CalendarDropdown } from "./CalendarDropdown";
import { PeopleCountDropdown } from "./PeopleCountDropdown";
import type { SearchValues } from "../types";

const datePopStyle = `
  .date-field-pop *, input, button, select, textarea {
    outline: none !important;
    box-shadow: none !important;
  }
  input:focus, button:focus, select:focus, textarea:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  @keyframes lilylankaDatePop {
    0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(124,58,237,0.45); }
    30% { transform: scale(1.04); box-shadow: 0 0 0 6px rgba(124,58,237,0.25); }
    60% { transform: scale(0.99); box-shadow: 0 0 0 2px rgba(124,58,237,0.15); }
    100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(124,58,237,0); }
  }
  .date-field-pop {
    animation: lilylankaDatePop 0.65s cubic-bezier(0.34, 1.56, 0.64, 1);
    border-radius: 0.5rem;
  }
  @keyframes lilylankaSearchBarPop {
    0% { opacity: 0; transform: scaleX(0.55) scaleY(0.85); }
    55% { opacity: 1; transform: scaleX(1.03) scaleY(1.03); }
    75% { transform: scaleX(0.99) scaleY(0.99); }
    100% { opacity: 1; transform: scaleX(1) scaleY(1); }
  }
  .search-bar-pop-in {
    animation: lilylankaSearchBarPop 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;
    transform-origin: center center;
  }
@keyframes lilylankaButtonPop {
    0% { transform: scale(0.55); opacity: 0; box-shadow: 0 0 0 0 rgba(124,58,237,0); }
    45% { transform: scale(1.14); opacity: 1; box-shadow: 0 0 0 12px rgba(124,58,237,0.25); }
    70% { transform: scale(0.97); box-shadow: 0 0 0 4px rgba(124,58,237,0.12); }
    100% { transform: none; opacity: 1; box-shadow: 0 0 0 0 rgba(124,58,237,0); }
  }
  .search-button-pop {
    animation: lilylankaButtonPop 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  }
@keyframes lilylankaFieldFadeUp {
    0% { opacity: 0; transform: translateY(10px); }
    100% { opacity: 1; transform: none; }
  }
  .field-fade-up {
    animation: lilylankaFieldFadeUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
  }
`;

// ─────────────────────────────────────────────────────────
// LOCATION INPUT
// ─────────────────────────────────────────────────────────
const LocationInputList = ({
  initialLocation,
  onLocationChange,
  onLocationSelect,
  onSearch,
  transparent = true,
}: {
  initialLocation: string;
  onLocationChange: (location: string, locationId?: number) => void;
  onLocationSelect: (location: string, locationId: number) => void;
  onSearch: () => void;
  transparent?: boolean;
}) => {
  const [inputValue, setInputValue] = useState(initialLocation);
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setInputValue(initialLocation);
  }, [initialLocation]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (value: string) => {
    setInputValue(value);
    onLocationChange(value, undefined);
    if (value.length < 2) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams({
          q: value,
          page: "1",
          pageSize: "10",
        });
        const response = await fetch(
          `https://www.lilylanka.com/api/CustomerDestinations?${params.toString()}`,
          {
            method: "GET",
            headers: { Accept: "application/json" },
            cache: "no-store",
          },
        );
        if (response.ok) {
          const data = await response.json();
          const locations =
            data.destinations?.map((dest: any) => ({
              uid: dest.id,
              name: dest.name,
              district: dest.district,
              province: dest.province,
            })) || [];
          setSuggestions(locations);
          setShowSuggestions(locations.length > 0);
        }
      } catch {
        setSuggestions([]);
        setShowSuggestions(false);
      } finally {
        setLoading(false);
      }
    }, 300);
  };

  const selectLocation = (location: any) => {
    setInputValue(location.name);
    onLocationSelect(location.name, location.uid);
    setShowSuggestions(false);
    setSuggestions([]);
  };

  return (
    <div className="relative w-full" ref={wrapperRef}>
      <div className="flex items-center gap-2 px-3 sm:px-4 h-10 sm:h-11 bg-transparent w-full touch-manipulation rounded-lg">
        <svg
          className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 ${
            transparent
              ? "text-white dark:text-white"
              : "text-gray-500 dark:text-zinc-400"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M22 2L11 13" />
          <path d="M22 2L15 22l-4-9-9-4 19-7z" />
        </svg>
        <input
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onSearch();
            }
          }}
          onFocus={() => {
            if (suggestions.length > 0) setShowSuggestions(true);
          }}
          placeholder="WHERE TO ?"
          className={`flex-1 bg-transparent outline-none focus:outline-none focus:ring-0 text-xs sm:text-sm min-w-0 ${
            transparent
              ? "placeholder:text-white dark:placeholder:text-white text-gray-900 dark:text-zinc-100"
              : "placeholder:text-gray-400 dark:placeholder:text-zinc-500 text-gray-900 dark:text-zinc-100"
          }`}
          autoComplete="off"
          inputMode="text"
          enterKeyHint="search"
        />
        {loading && (
          <Loader2 className="w-3.5 h-3.5 sm:w-4 sm:h-4 animate-spin text-gray-400 dark:text-zinc-500 flex-shrink-0" />
        )}
      </div>

      {showSuggestions && suggestions.length > 0 && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-zinc-900 border border-gray-100 dark:border-zinc-800 rounded-xl shadow-xl z-[999] max-h-72 overflow-y-auto">
          {suggestions.map((s) => (
            <button
              key={s.uid}
              type="button"
              onClick={() => selectLocation(s)}
              className="w-full px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-zinc-800 active:bg-gray-100 dark:active:bg-zinc-700 flex items-center gap-3 border-b border-gray-100 dark:border-zinc-800 last:border-b-0 touch-manipulation transition-colors"
            >
              <MapPin className="w-4 h-4 text-gray-400 dark:text-zinc-500 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm text-gray-900 dark:text-zinc-100">
                  {s.name}
                </div>
                <div className="text-xs text-gray-500 dark:text-zinc-400">
                  {s.district}, {s.province}
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────
// ERROR TOOLTIP
// ─────────────────────────────────────────────────────────
function ErrorTooltip({ message }: { message: string }) {
  return (
    <div className="absolute left-0 right-0 top-full mt-1 z-50">
      <div className="bg-red-600 text-white text-xs font-medium px-3 py-2 rounded-lg shadow-lg flex items-center gap-2">
        <span className="flex-shrink-0">⚠</span>
        {message}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────
// FIELD WRAPPER — consistent border + dark bg
// ─────────────────────────────────────────────────────────
function FieldWrap({
  children,
  error,
  className = "",
  transparent = true,
}: {
  children: React.ReactNode;
  error?: boolean;
  className?: string;
  transparent?: boolean;
}) {
  return (
    <div
      className={`border rounded-lg transition-colors overflow-visible focus-within:outline-none focus-within:ring-0 focus-within:border-purple-400 dark:focus-within:border-purple-500 ${
        transparent
          ? "bg-white/10 dark:bg-zinc-900/20 hover:bg-white/20 dark:hover:bg-zinc-900/30 hover:border-white/50 dark:hover:border-zinc-600"
          : "bg-white dark:bg-zinc-900 hover:bg-gray-50 dark:hover:bg-zinc-800 hover:border-gray-400 dark:hover:border-zinc-600"
      } ${
        error
          ? "border-red-500 dark:border-red-500"
          : transparent
            ? "border-white/30 dark:border-zinc-700"
            : "border-gray-300 dark:border-zinc-700"
      } ${className}`}
    >
      {children}
    </div>
  );
}

// ─────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────
function HotelSearchBarContent({
  variant = "list",
  onValuesChange,
  transparent = true,
}: {
  variant?: "list";
  onValuesChange?: (values: SearchValues) => void;
  transparent?: boolean;
}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isMobile, setIsMobile] = useState(false);
  const [values, setValues] = useState<SearchValues>({
    location: "",
    locationId: undefined,
    checkIn: "",
    checkOut: "",
    guests: 2,
    adults: 2,
    children: 0,
    rooms: 1,
    searchText: "",
  });
  const [locationError, setLocationError] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [datePop, setDatePop] = useState(false);

  // ── Entrance choreography: button pops in first, then fields grow open ──
  const [fieldsRevealed, setFieldsRevealed] = useState(false);
  const [revealSettled, setRevealSettled] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFieldsRevealed(true), 350);
    const t2 = setTimeout(() => setRevealSettled(true), 1150);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    const handleRequireDates = () => {
      setDateError(true);
      setDatePop(true);
      setTimeout(() => setDatePop(false), 650);
    };
    window.addEventListener("lilylanka:require-dates", handleRequireDates);
    return () =>
      window.removeEventListener("lilylanka:require-dates", handleRequireDates);
  }, []);

  useEffect(() => {
    const location = searchParams.get("location") || "";
    const locationId = searchParams.get("locationId");
    const checkIn = searchParams.get("checkIn") || "";
    const checkOut = searchParams.get("checkOut") || "";
    const adults = parseInt(searchParams.get("adults") || "2");
    const children = parseInt(searchParams.get("children") || "0");
    const rooms = parseInt(searchParams.get("rooms") || "1");
    const searchText = searchParams.get("searchText") || "";
    setValues({
      location,
      locationId: locationId ? parseInt(locationId) : undefined,
      checkIn,
      checkOut,
      guests: adults + children,
      adults,
      children,
      rooms,
      searchText,
    });
  }, [searchParams]);

  useEffect(() => {
    onValuesChange?.(values);
  }, [values.adults, values.children, values.rooms, values.searchText]);

  const handleSearch = useCallback(() => {
    const hasDateError = !values.checkIn || !values.checkOut;
    setLocationError(false);
    setDateError(hasDateError);
    if (hasDateError) return;

    const totalGuests = values.adults + values.children;
    const params = new URLSearchParams({
      location: values.location,
      checkIn: values.checkIn,
      checkOut: values.checkOut,
      guests: String(totalGuests || 1),
      adults: String(values.adults),
      children: String(values.children),
      rooms: String(values.rooms),
    });
    if (values.locationId) params.set("locationId", String(values.locationId));
    router.push("/hotels?" + params.toString());
  }, [values, router]);

  const handleLocationChange = useCallback(
    (location: string, locationId?: number) => {
      setValues((prev) => ({ ...prev, location, locationId }));
    },
    [],
  );

  const handleLocationSelect = useCallback(
    (location: string, locationId: number) => {
      setValues((prev) => ({ ...prev, location, locationId }));
    },
    [],
  );

  if (variant === "list") {
    return (
      <>
        <style dangerouslySetInnerHTML={{ __html: datePopStyle }} />
        <div
          className={`search-bar-pop-in rounded-lg overflow-visible shadow-lg ${
            transparent
              ? "bg-white/20 dark:bg-zinc-900/30 backdrop-blur-xl border border-white/30 dark:border-zinc-700/40"
              : "bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-700"
          }`}
        >
          <div className="max-w-6xl mx-auto px-3 sm:px-4 lg:px-6 py-2 sm:py-4 overflow-visible">
            {isMobile ? (
              <div className="flex flex-col gap-2">
                <div
                  className={fieldsRevealed ? "field-fade-up" : "opacity-0"}
                  style={{
                    animationDelay: "120ms",
                    position: "relative",
                    zIndex: 30,
                  }}
                >
                  <FieldWrap error={locationError} transparent={transparent}>
                    <LocationInputList
                      initialLocation={values.location}
                      transparent={transparent}
                      onLocationChange={(loc, id) => {
                        handleLocationChange(loc, id);
                        if (loc.trim()) setLocationError(false);
                      }}
                      onLocationSelect={(loc, id) => {
                        handleLocationSelect(loc, id);
                        setLocationError(false);
                      }}
                      onSearch={handleSearch}
                    />
                  </FieldWrap>
                  {locationError && (
                    <ErrorTooltip message="Please enter a destination to start searching." />
                  )}
                </div>

                <div
                  className={fieldsRevealed ? "field-fade-up" : "opacity-0"}
                  style={{
                    animationDelay: "220ms",
                    position: "relative",
                    zIndex: 20,
                  }}
                >
                  <FieldWrap error={dateError} transparent={transparent}>
                    <CalendarDropdown
                      checkIn={values.checkIn}
                      checkOut={values.checkOut}
                      transparent={transparent}
                      onCheckInChange={(v) => {
                        setValues((s) => ({ ...s, checkIn: v }));
                        if (v) setDateError(false);
                      }}
                      onCheckOutChange={(v) => {
                        setValues((s) => ({ ...s, checkOut: v }));
                        if (v) setDateError(false);
                      }}
                    />
                  </FieldWrap>
                  {dateError && (
                    <ErrorTooltip message="Please select check-in and check-out dates." />
                  )}
                </div>

                <div
                  className={fieldsRevealed ? "field-fade-up" : "opacity-0"}
                  style={{
                    animationDelay: "320ms",
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  <FieldWrap transparent={transparent}>
                    <PeopleCountDropdown
                      values={values}
                      setValues={setValues}
                      transparent={transparent}
                    />
                  </FieldWrap>
                </div>

                <button
                  onClick={handleSearch}
                  className="search-button-pop w-full flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-700 active:bg-purple-800 text-white font-semibold rounded-full py-3 text-sm ring-4 ring-purple-300/40 dark:ring-purple-500/30 transition-colors touch-manipulation cursor-pointer"
                >
                  <Search className="w-4 h-4" strokeWidth={2.5} />
                  Search
                </button>
              </div>
            ) : (
              <div
                className="grid items-stretch gap-2 sm:gap-3"
                style={{
                  gridTemplateColumns:
                    "minmax(200px, 1fr) max-content max-content auto",
                }}
              >
                <div
                  className="relative min-w-0 transition-opacity ease-out"
                  style={{
                    opacity: fieldsRevealed ? 1 : 0,
                    overflow: revealSettled ? "visible" : "hidden",
                    transitionDuration: "650ms",
                    transitionDelay: "120ms",
                  }}
                >
                  <FieldWrap error={locationError} transparent={transparent}>
                    <LocationInputList
                      initialLocation={values.location}
                      transparent={transparent}
                      onLocationChange={(loc, id) => {
                        handleLocationChange(loc, id);
                        if (loc.trim()) setLocationError(false);
                      }}
                      onLocationSelect={(loc, id) => {
                        handleLocationSelect(loc, id);
                        setLocationError(false);
                      }}
                      onSearch={handleSearch}
                    />
                  </FieldWrap>
                  {locationError && (
                    <ErrorTooltip message="Please enter a destination to start searching." />
                  )}
                </div>

                <div
                  className={`relative transition-opacity ease-out ${
                    datePop ? "date-field-pop" : ""
                  }`}
                  style={{
                    opacity: fieldsRevealed ? 1 : 0,
                    overflow: revealSettled ? "visible" : "hidden",
                    transitionDuration: "650ms",
                    transitionDelay: "240ms",
                  }}
                >
                  <FieldWrap error={dateError} transparent={transparent}>
                    <CalendarDropdown
                      checkIn={values.checkIn}
                      checkOut={values.checkOut}
                      transparent={transparent}
                      onCheckInChange={(v) => {
                        setValues((s) => ({ ...s, checkIn: v }));
                        if (v) setDateError(false);
                      }}
                      onCheckOutChange={(v) => {
                        setValues((s) => ({ ...s, checkOut: v }));
                        if (v) setDateError(false);
                      }}
                    />
                  </FieldWrap>
                  {dateError && (
                    <ErrorTooltip message="Please select check-in and check-out dates." />
                  )}
                </div>

                <div
                  className="transition-opacity ease-out"
                  style={{
                    opacity: fieldsRevealed ? 1 : 0,
                    overflow: revealSettled ? "visible" : "hidden",
                    transitionDuration: "650ms",
                    transitionDelay: "360ms",
                  }}
                >
                  <FieldWrap transparent={transparent}>
                    <PeopleCountDropdown
                      values={values}
                      setValues={setValues}
                      transparent={transparent}
                    />
                  </FieldWrap>
                </div>

                <button
                  onClick={handleSearch}
                  className="search-button-pop flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-700 active:bg-purple-800 text-white font-semibold rounded-full px-6 sm:px-8 py-2.5 text-sm ring-4 ring-purple-300/40 dark:ring-purple-500/30 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <Search className="w-4 h-4" strokeWidth={2.5} />
                  Search
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  return null;
}

// ─────────────────────────────────────────────────────────
// WRAPPER + EXPORT
// ─────────────────────────────────────────────────────────
function HotelSearchBarWrapper({
  variant = "list",
  onValuesChange,
  transparent = true,
}: {
  variant?: "list";
  onValuesChange?: (values: SearchValues) => void;
  transparent?: boolean;
}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="w-full rounded-2xl bg-white/95 dark:bg-zinc-900/95 shadow-xl px-4 py-3 animate-pulse">
        <div className="h-10 bg-gray-200 dark:bg-zinc-700 rounded" />
      </div>
    );
  }

  return (
    <HotelSearchBarContent
      variant={variant}
      onValuesChange={onValuesChange}
      transparent={transparent}
    />
  );
}

export default function HotelSearchBar({
  variant = "list",
  onValuesChange,
  transparent = true,
}: {
  variant?: "list";
  onValuesChange?: (values: SearchValues) => void;
  transparent?: boolean;
}) {
  return (
    <Suspense
      fallback={
        <div className="w-full rounded-2xl bg-white/95 dark:bg-zinc-900/95 shadow-xl px-4 py-3 animate-pulse">
          <div className="h-10 bg-gray-200 dark:bg-zinc-700 rounded" />
        </div>
      }
    >
      <HotelSearchBarWrapper
        variant={variant}
        onValuesChange={onValuesChange}
        transparent={transparent}
      />
    </Suspense>
  );
}
